<template>
  <div class="dmss-login">
    <div class="login-box">
      <el-scrollbar height="100%" style="width: 100%">
        <div class="top-dmss">
          <img style="height: 34px" :src="loginIcon" alt="" />
          <div class="DMSS">{{ getAppName(appName) }}</div>
        </div>
        <div class="login">
          <div class="account-incorect" v-if="loginError">
            <img src="@/assets/imgs/error-x.svg" alt="" />
            <div class="incorrect-tip">
              Email Address or password is incorrect.
            </div>
          </div>
          <div class="email-phone">
            <div
              :class="`email ${loginType === 1 ? 'email-select' : ''}`"
              @click="changeLoginType(1)"
            ></div>
            <div
              class="phone"
              :class="`phone ${loginType === 2 ? 'phone-select' : ''}`"
              @click="changeLoginType(2)"
            ></div>
          </div>
          <div v-if="loginType === 1" class="login-email">
            <el-form
              ref="emailForm"
              label-position="top"
              :rules="emailRules"
              :model="emailFormData"
            >
              <el-form-item label="Account" prop="account">
                <el-input
                  :max-length="32"
                  v-model="emailFormData.account"
                  placeholder="Enter your email address"
                ></el-input>
              </el-form-item>
              <el-form-item label="Password" prop="password">
                <el-input
                  type="password"
                  :max-length="32"
                  v-model="emailFormData.password"
                  placeholder="Enter password"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div v-else class="login-phone">
            <el-form
              label-position="top"
              ref="phoneForm"
              :rules="phoneRules"
              :model="phoneFormData"
            >
              <el-form-item label="Phone Number" prop="account">
                <el-input
                  class="phone-input"
                  :max-length="32"
                  v-model="phoneFormData.account"
                  placeholder="Phone Number"
                >
                  <template #prefix>
                    <el-dropdown
                      @command="choosePre"
                      trigger="click"
                      placement="bottom-start"
                      popper-class="phone-pre-dropdown"
                    >
                      <div class="dropdown-pre">
                        <span>{{ phoneFormData.pre }}</span>
                        <el-icon class="el-icon--right"><arrow-down /></el-icon>
                      </div>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <el-scrollbar height="20rem">
                            <el-dropdown-item
                              v-for="item in countries"
                              :key="item.PhonePre"
                              :command="item"
                            >
                              <div class="country-item">
                                <div class="phone-pre">
                                  {{ item.PhonePre }}
                                </div>
                                <div class="name-en">{{ item.enName }}</div>
                              </div>
                            </el-dropdown-item>
                          </el-scrollbar>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item label="Password" prop="password">
                <el-input
                  :max-length="6"
                  type="password"
                  v-model="phoneFormData.password"
                  placeholder="Enter password"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <el-button
          :loading="loginLoading"
          size="large"
          type="primary"
          style="width: 100%; margin-top: 4rem"
          @click="loginHander"
          >Login</el-button
        >

        <div v-if="appName === 'DMSS'" class="qr">
          <div class="qr-pic">
            <img src="@/assets/imgs/qr.png" alt="" />
          </div>
          <div class="qr-desc">
            <div class="title">App Download</div>
            <div class="content">
              Scan code to download and experience DMSS App
            </div>
          </div>
        </div>
        <div :style="`height: ${appName === 'DMSS' ? 4 : 8}rem;`"></div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, inject, onMounted, computed, watch } from "vue";
import { ArrowDown } from "@element-plus/icons-vue";
import { countries, getIcon, getAppName } from "@/utils/const.js";
import CryptoJS from "crypto-js";
import { ElMessage } from "element-plus";
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();
const $api = inject("$api");
const loginType = ref(1); /** 1： 邮箱 2： 手机 */

const projectInfo = reactive({
  project: "",
  appid: "",
  appname: "",
});
const appName = computed(() => {
  let name = projectInfo.project;
  if (projectInfo.project === "Base") {
    if (projectInfo.appname) {
      name = projectInfo.appname;
    } else {
      name = "DMSS";
    }
  } else if (!projectInfo.project) {
    name = "DMSS";
  }
  console.log(name, 'appname')
  return name;
});

watch(
  () => appName.value,
  (newValue, oldValue) => {
    document.title = getAppName(newValue);
  },
  { immediate: true }
);
const loginIcon = computed(() => {
  console.log(getIcon(appName.value, true), 'geticon')
  return getIcon(appName.value, true);
});
watch(
  () => loginIcon.value,
  () => {
    let $favicon = document.querySelector('link[rel="icon"]');

    if ($favicon !== null) {
      $favicon.href = loginIcon.value;
    } else {
      $favicon = document.createElement("link");
      $favicon.rel = "icon";
      $favicon.href = loginIcon.value;
      document.head.appendChild($favicon);
    }
  }
);
onMounted(() => {
  const {
    query: { project, appid, appname },
  } = route;
  // const baseOrigins = [
  //   "https://dmss.dolynkcloud.com",
  //   "https://dmss-fe.dolynkcloud.com",
  //   "https://dmss-ec.dolynkcloud.com",
  //   "https://dmss-di.dolynkcloud.com",
  // ];
  // console.log(project, appid, 'ppid')
  // if (location.origin !== "http://localhost:8000" && location.origin !== "http://10.54.24.148:8000") {
  //   const isBase = baseOrigins.some((item) => item === location.origin);
  //   if (isBase) {
  //     if (Reflect.ownKeys(route.query).length) {
  //       router.push("/404");
  //     }
  //   } else {
  //     if (!project || !appid) {
  //       router.push("/404");
  //     }
  //   }
  // }

  projectInfo.project = project;
  projectInfo.appid = appid;
  projectInfo.appname = appname;
  sessionStorage.setItem(
    "projectInfo",
    JSON.stringify({
      project,
      appid,
      appname,
    })
  );
});

function changeLoginType(v) {
  loginType.value = v;
}
// 邮箱登陆
const emailFormData = reactive({
  account: "",
  password: "",
});

// 邮箱验证
const emailRules = {
  account: [
    {
      required: true,
      message: "Enter your email address",
    },
  ],
  password: [{ required: true, message: "Enter password" }],
};

// 手机登陆
const phoneFormData = reactive({
  account: "",
  pre: "+86",
  password: "",
});

function choosePre(params) {
  phoneFormData.pre = params.PhonePre;
}
// 手机验证
const phoneRules = {
  account: [{ required: true, message: "Enter your phone number" }],
  password: [{ required: true, message: "Enter your phone number" }],
};

// 登陆
const loginError = ref(false);

const emailForm = ref();
const phoneForm = ref();
const loginLoading = ref(false);
async function loginHander() {
  let res = null;
  loginType.value === 1
    ? await emailForm.value.validate()
    : await phoneForm.value.validate();
  // 邮箱登陆
  loginLoading.value = true;
  const { password, account, pre } =
    loginType.value === 1 ? emailFormData : phoneFormData;
  const passwordMD5 = CryptoJS.enc.Utf8.parse(CryptoJS.MD5(password));
  const key = CryptoJS.enc.Utf8.parse(CryptoJS.MD5("DAHUAKEY").toString());
  const iv = CryptoJS.enc.Utf8.parse("0a52uuEvqlOLc5TO");
  const passwordAES = CryptoJS.AES.encrypt(passwordMD5, key, {
    mode: CryptoJS.mode.CBC,
    iv,
    padding: CryptoJS.pad.Pkcs7,
  });

  const params = {
    timezoneOffset: new Date().getTimezoneOffset() * 60 * 1000,
    password: passwordAES.ciphertext.toString(CryptoJS.enc.Base64),
    account: account,
    origin: password,
  };
  if (loginType.value === 2) {
    params.areaCode = pre.slice(1, pre.length);
  }
  res = (await $api.login.login({ data: params })).data;
  const { desc, code, data } = res;
  if (code === 10000) {
    if (Reflect.has(data, "failNum")) {
      ElMessage.error("The username or password is incorrect.");
    } else {
      sessionStorage.setItem("loginInfo", JSON.stringify(data));
      router.push("/account");
    }
  } else if (code === 12318) {
    ElMessage.error("The username not exist.");
  } else if (code === "10009") {
    ElMessage.error(
      "The account has been locked, please try again in 5 minutes."
    );
  }

  loginLoading.value = false;
}
</script>

<style lang="scss" scoped>
.dmss-login {
  width: 100vw;
  height: 100vh;
  background: rgb(153, 202, 254);

  .login-box {
    /* 矩形 29 */
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    right: 20.8rem;
    width: 44rem;
    border-radius: 0.8rem;
    background: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 6rem;
    .top-dmss {
      margin-top: 7rem;
      display: flex;
      align-items: center;
      font-size: 1.6rem;
      font-weight: 700;

      img {
        margin-right: 1.2rem;
      }
    }

    .login {
      margin-top: 8rem;
      width: 100%;

      .account-incorect {
        display: flex;
        height: 3.6rem;
        line-height: 3.6rem;
        align-items: center;
        box-sizing: border-box;
        border: 1px solid rgb(242, 86, 69);
        border-radius: 4px;
        background: rgba(242, 86, 69, 0.16);
        padding-left: 1.2rem;
        margin-bottom: 1.4rem;

        img {
          width: 1.6rem;
          margin-right: 1rem;
        }

        .incorrect-tip {
          color: rgb(78, 89, 105);
          font-family: Outfit;
          font-size: 1.4rem;
          font-weight: 400;
          line-height: 1.8rem;
          text-align: left;
        }
      }

      .email-phone {
        display: flex;
        margin-bottom: 1.6rem;

        .email {
          width: 4.4rem;
          height: 4.2rem;
          margin-right: 3.6rem;
          background: url("~@/assets/imgs/email.svg") center center no-repeat;
          background-size: 3.8rem;
          border-bottom: 2px solid transparent;

          &-select,
          &:hover {
            background: url("~@/assets/imgs/email-h.svg") center center
              no-repeat;
            border-bottom: 2px solid rgb(65, 156, 252);
            background-size: 3.8rem;
          }
        }

        .phone {
          width: 4.4rem;
          height: 4.2rem;
          margin-right: 1.6rem;
          background: url("~@/assets/imgs/phone.svg") center center no-repeat;
          background-size: 2.4rem;
          border-bottom: 2px solid transparent;

          &-select,
          &:hover {
            background: url("~@/assets/imgs/phone-hover.svg") center center
              no-repeat;
            border-bottom: 2px solid rgb(65, 156, 252);
            background-size: 2.4rem;
          }
        }
      }

      .login-phone {
        .dropdown-pre {
          cursor: pointer;
          border-right: 1px solid #dcdfe6;
          padding-right: 0.8rem;
          padding-left: 1.1rem;

          .el-icon--right {
            margin-left: 2.4rem;
          }
        }
      }
    }
    .login-btn {
    }
    .qr {
      display: flex;
      margin-top: 4rem;
      align-items: center;
      .qr-pic {
        margin-right: 1.2rem;
        img {
          width: 9.2rem;
        }
      }
      .qr-desc {
        .title {
          color: rgb(39, 46, 59);
          font-family: Outfit;
          font-size: 1.4rem;
        }
        .content {
          color: rgb(134, 144, 156);
          font-family: Outfit;
          font-size: 1.2rem;
          margin-top: 0.8rem;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.phone-input {
  .el-input__wrapper {
    padding-left: 0;
  }
}

.phone-pre-dropdown {
  width: 32rem;

  .country-item {
    display: flex;
    height: 3.2rem;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
